import { render, staticRenderFns } from "./ApiPagination.vue?vue&type=template&id=c862b76a&"
import script from "./ApiPagination.vue?vue&type=script&lang=js&"
export * from "./ApiPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports